import { BrowserRouter, Navigate, Route, Routes, } from 'react-router-dom';
import './App.css';
import ProtectedRoute from './auth/ProtectedRoute';
import RightRoute from './auth/RightRoute';
import TwoFactorGate, { TWO_FACTOR_SETUP_PATH } from './auth/TwoFactorGate';
import TwoFactorSetup from './pages/TwoFactorSetup';
import Home from './pages/Home';
import AdminPanel from './pages/AdminPanel';
import InterfacePage from './pages/InterfacePage';
import MediaPoolPage from './pages/MediaPoolPage';
import Account from './pages/Account';
import About from './pages/About';
import Login from './pages/Login';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import NotFound from './pages/NotFound';
import ArticlePage from './components/MainWindow.js';
import GuestRoute from './auth/GuestRoute';
import NewsToast from './components/NewsToast';
import Favorites from './pages/FavoritesPage';
import CreateArticle from './pages/CreateArticle';
import CreateArticleChoice from './pages/CreateArticleChoice.js';
import CreateArticleUpload from './pages/CreateArticleUpload';
import CreateArticleHtml from './pages/CreateArticleHtml';
import CreateArticleRise from './pages/CreateArticleRise';
import ArticlesPage from './components/ArticlesPage.js';
import MyArticlesPage from './components/MyArticlesPage.js';
import ArticlesByTag from './pages/ArticlesByTag.js';
import SidebarPage from './components/SidebarPage.js';
import SimulationLaunch from './pages/SimulationLaunch';
import Archive from './pages/Archive';
import ArticleHistory from './pages/ArticleHistory';
import ArchivedArticleView from './components/ArchiveView';
import AdminHome from './components/AdminHome';
import AdminToolsPage from './pages/AdminToolsPage';
import AdminPluginsPage from './pages/AdminPluginsPage';
import AdminPluginSettingsPage from './pages/AdminPluginSettingsPage';

function App() {
  return (
    <BrowserRouter>
      <TwoFactorGate>
      <NewsToast />

      <Routes>

        <Route element={<GuestRoute />}>
          <Route
            path="/login"
            element={<Login />}
          />
        </Route>

        <Route element={<ProtectedRoute />}>

          <Route
            path={TWO_FACTOR_SETUP_PATH}
            element={<TwoFactorSetup />}
          />

          <Route
            path="/"
            element={<Home />}
          />

          <Route
            path="/account"
            element={<Account />}
          />

          <Route
            path="/simulation/:id"
            element={<SimulationLaunch />}
          />

          <Route
            path="/about"
            element={<About />}
          />

          <Route
            path="/favorites"
            element={<Favorites />}
          />

          <Route
            path="/my-articles"
            element={<MyArticlesPage />}
          />

          <Route
            path="/news"
            element={<News />}
          />

          <Route
            path="/news/:id"
            element={<NewsDetail />}
          />

          <Route
            path="/article/:id"
            element={<ArticlePage />}
          />

          <Route
            path="/articles"
            element={<ArticlesPage />}
          />

          <Route
            path="/archive"
            element={<Archive />}
          />

          <Route
            path="/archive/:id/history"
            element={<ArticleHistory />}
          />

          <Route
            path="/archive/article/:id"
            element={<ArchivedArticleView />}
          />

          <Route
            path="/sidebar/:id"
            element={<SidebarPage />}
          />

          <Route
            path="/tag/:tagName"
            element={<ArticlesByTag />}
          />

        </Route>

        {/* Administering one department is enough to open the panel; each
            block inside it appears only with the right it needs. */}
        {/* Creating needs the manage right of the kind: the links are hidden
            without it, and a typed URL lands here and is sent home. */}
        <Route
          element={
            <RightRoute
              right={['articles.manage', 'news.manage']}
              scope="anywhere"
            />
          }
        >
          <Route
            path="/create-article"
            element={<CreateArticleChoice />}
          />

          <Route
            path="/create-article/manual"
            element={<CreateArticle />}
          />

          <Route
            path="/create-article/link"
            element={<CreateArticle linkMode />}
          />

          <Route
            path="/create-news"
            element={<Navigate to="/create-article" replace />}
          />
        </Route>



        {/* An import (PDF, Rise course) always starts an article, never a news item. */}
        <Route element={<RightRoute right="articles.manage" scope="anywhere" />}>
          <Route
            path="/create-article/upload"
            element={<CreateArticleUpload />}
          />

          <Route
            path="/create-article/rise"
            element={<CreateArticleRise />}
          />

          <Route
            path="/create-article/interactive"
            element={<CreateArticleHtml />}
          />

          {/* Processes are the process plugin now; old links keep working. */}
          <Route
            path="/create-article/process"
            element={<Navigate to="/create-article/plugin/process-tool" replace />}
          />
        </Route>

        {/* A plugin's card: the plugin names the right (articles.manage or news.manage). */}
        <Route element={<RightRoute right={['articles.manage', 'news.manage']} scope="anywhere" />}>
          <Route
            path="/create-article/plugin/:pluginId"
            element={<CreateArticle />}
          />
        </Route>

        <Route element={<RightRoute right="admin.access" scope="anywhere" />}>
          <Route

            path="/admin"
            element={<AdminHome />}
          />

          <Route

            path="/admin/rechte"
            element={<AdminPanel />}
          />

          <Route
          
            path="/admin/werkzeuge"
            element={<AdminToolsPage />}
          />
        </Route>

        {/* Plugins: platform-wide for all departments, or in one's own departments. */}
        <Route element={<RightRoute right="plugins.manage" scope="anywhere" />}>
          <Route
            path="/admin/plugins"
            element={<AdminPluginsPage />}
          />

          <Route
            path="/admin/plugins/:pluginId"
            element={<AdminPluginSettingsPage />}
          />
        </Route>

        <Route element={<RightRoute right="interface.manage" />}>

          <Route
            path="/interface"
            element={<InterfacePage />}
          />

        </Route>

        <Route element={<RightRoute right="media.manage" />}>

          <Route
            path="/admin/media"
            element={<MediaPoolPage />}
          />

        </Route>

        <Route
          path="*"
          element={<NotFound />}
        />*


      </Routes>
      </TwoFactorGate>
    </BrowserRouter>
  );
}

export default App;